import { Typography } from '@mui/material';
import Dompurify from 'dompurify';

import { CollapsibleSection } from '@eng-mono/atlassian/jira/mojira-bugtracker/frontend-feature-issue-list-collapsible-section'
import { JsmIssueBase } from '@eng-mono/atlassian/jira/mojira-bugtracker/util-issue-list-fe';

interface DescriptionCollapseProps {
  issue: JsmIssueBase;
  expanded: boolean;
  toggleSection: () => void;
}

const modifyAnchorLinks = (htmlString: string): string => {
  if (!htmlString) return "";

  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, "text/html");

  doc.querySelectorAll("a").forEach((anchor) => {
    try {
      if (anchor.href.includes('atlassian')) {
        const url = new URL(anchor.href);
        if (anchor.href.includes('atlassian'))
        url.href = `${window.location.origin}${url.pathname}`;
        anchor.href = url.toString();
      }
    } catch (error) {
      console.error("Invalid URL:", anchor.href);
    }
  });

  return doc.body.innerHTML;
};

export function DescriptionCollapse({
  issue,
  expanded,
  toggleSection,
}: DescriptionCollapseProps) {
  const modifiedDescription = modifyAnchorLinks(issue.renderedFields.description);
  return (
    <CollapsibleSection title="Description" expanded={expanded} setExpanded={toggleSection}>
      <Typography
        dangerouslySetInnerHTML={{
          __html: Dompurify.sanitize(modifiedDescription),
        }}
        sx={{
          marginBottom: 2,
          "& pre": {
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            overflowX: "auto",
            backgroundColor: "#f5f5f5",
            padding: "8px",
            borderRadius: "4px",
            fontFamily: "monospace"
          }
        }}
      ></Typography>
    </CollapsibleSection>
  );
}

